import * as React from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import { Provider } from 'mobx-react'
import { createBrowserHistory } from 'history'
import {
  initializeStore,
  USER_STORE,
  NAVIGATION_STORE,
  PHOTOS_STORE,
  WORKSPACES_STORE,
} from './app/stores'
import App from './app'
import i18n from './app/i18n/i18n'
import { I18nextProvider } from 'react-i18next'
import { AddPhotosStore, ADD_PHOTOS_STORE } from './app/stores/AddPhotosStore'
import { PhotosStore } from './app/stores/PhotosStore'
import { ModalStore, MODAL_STORE } from './app/stores/ModalStore'
import * as mobx from 'mobx'
import { SnackbarProvider } from 'notistack'
import { WorkspacesStore } from './app/stores/WorkspaceStore'
import { HelmetProvider } from 'react-helmet-async'

// don't allow state modifications outside actions
mobx.configure({ enforceActions: 'observed' })

// prepare i18n

// prepare MobX stores
const history = createBrowserHistory()
// TODO: create store snapshot saving
const storeSnapshot = null
const rootStore = initializeStore(storeSnapshot)

const workspaceStore = new WorkspacesStore()

const otherStores = {
  [USER_STORE]: rootStore[USER_STORE],
  [NAVIGATION_STORE]: rootStore.navigationStore,
  [ADD_PHOTOS_STORE]: new AddPhotosStore(workspaceStore),
  [PHOTOS_STORE]: new PhotosStore(workspaceStore),
  [MODAL_STORE]: new ModalStore(),
  [WORKSPACES_STORE]: workspaceStore,
}
// render react DOM
const container = document.getElementById('root')!
const root = createRoot(container)
root.render(
  <I18nextProvider i18n={i18n}>
    <Provider rootStore={rootStore} {...otherStores}>
      <HelmetProvider>
        <SnackbarProvider maxSnack={3}>
          <App history={history} />
        </SnackbarProvider>
      </HelmetProvider>
    </Provider>
  </I18nextProvider>
)
